import AdminClient from '../client/AdminClient';

class PersonService {
    static async datasetRecords(params, session) {
        return AdminClient.get(`/v1/admin/people/dataset_records`, session, params);
    }
}

export default PersonService;
